import "./Item.css";
import { ItemDetailsData } from "../../../../Utils/DefinitionsInterfaces";
import { useContext } from "react";
import { CartContext } from "../../../../App";

interface ItemPropsInterface {
  stateCheckoutItem: ItemDetailsData;
  isDefaultItem: boolean;
  cbRemoveProduct: (itemId: number) => void;
}

const Item = (props: ItemPropsInterface) => {
  const { bundleInfo, checkOutItems } = useContext(CartContext);

  // Check if bundle pricing should apply to this item
  const shouldShowBundlePrice = () => {
    if (!bundleInfo.isBundle || !bundleInfo.primaryProductId) return false;

    // Don't apply bundle pricing to the primary product itself
    if (props.stateCheckoutItem.id === bundleInfo.primaryProductId)
      return false;

    // Check if primary product is in the cart
    const primaryProductInCart = checkOutItems.some(
      (item) => item.id === bundleInfo.primaryProductId
    );

    return primaryProductInCart;
  };

  const getDisplayPrice = () => {
    return shouldShowBundlePrice()
      ? props.stateCheckoutItem.discountedBundlePrice
      : props.stateCheckoutItem.selling_price;
  };

  const RoundComponent = () => {
    return (
      <div
        style={{
          height: "10px",
          width: "10px",
          backgroundColor: "rgba(154, 200, 254, 0.3)",
          border: "2px",
          borderColor: "rgba(35, 81, 136, 1)",
          borderRadius: 100,
          marginLeft: "10px",
          marginRight: "10px",
          marginTop: "10px",
        }}
      ></div>
    );
  };

  return (
    <div className="item">
      <div className="wrap">
        <div className="item-title">{props.stateCheckoutItem.name}</div>
        <div
          style={{ display: "flex", justifyContent: "center", width: "100%" }}
        >
          <div
            style={{
              width: "60%",
              height: "2px",
              backgroundColor: "rgba(217, 217, 217, 1)",
              alignSelf: "center",
              marginRight: "10px",
            }}
          ></div>
          <div>
            <span
              style={{ textDecoration: "line-through", marginRight: "10px" }}
              className="text-wrapper-3"
            >
              {"₹" + props.stateCheckoutItem.base_price}
            </span>
            <span className="text-wrapper-3">{"₹" + getDisplayPrice()}</span>
          </div>
        </div>
      </div>

      <div className="item-description">
        <br />
        <div className="item-details-breakdown">
          <RoundComponent />
          <div className="item-details-text">
            {props.stateCheckoutItem.description}
          </div>
        </div>
        <br />
        <div className="item-details-breakdown">
          <RoundComponent />
          <div className="item-details-text">
            A copy of the NFO Handbook will be delivered to the provided address
            within 7 to 8 business days.
          </div>
        </div>
        <br />
      </div>
    </div>
  );
};

export default Item;
